import { useFragment } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
import { SubmitSelection } from './SubmitSelection';
export function AddMetadataSimpleTextSelection(props) {
    const { from } = props;
    const [field, , helpers] = useField('value');
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Menu.HeaderInput type="text" value={field.value} onChange={helpers.setValue} placeholder={t({
            message: 'Enter text...',
            comment: 'Metadata: Add metadata number pair - Input placeholder',
        })}/>
      <SubmitSelection />
      <RemoveSelection />
    </Menu.ItemNested>);
}
